/* TODOS
1. add visual unit function -> insert visual unit into the workspace
2. remove visual unit function -> remove visual unit from the workspace 
3. figure out rest of todos 


*/

import { useEffect, useState, createContext, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getAppSettings, getCurrentUserData, RootState } from '../../Redux/store'
import { useSubmitFormMutation } from '../../Redux/Workspace/workspaceSlice'
import {
    useGetProtectedAppSettingsQuery,
    IPrivateAppSettingResponse,
} from '../../Redux/App/appSlice'
import IndividualSummary from '../../Components/SummaryTiles/Summary'
import WorkspaceActionsDropdown from './workspaceActionsDropdown'
import { FoundationsEnums } from '../../enum'
import { setWorkspaceActions } from '../../Redux/Workspace/workspaceActionReducers'
import {
    setVuObjectInfoStore,
    setVuParamsInfoStore,
} from '../../Redux/VisualUnits/visualUnitStateSlice'
import AddWorkspaceDialog from '../HomePage/WorkspaceDialogs/AddNewWorkspaceDialog'
import DeleteWorkspaceDialog from '../HomePage/WorkspaceDialogs/DeleteWorkspace'
import {
    useCheckDeleteWorkspaceMutation,
    useGetDBVisualUnitsMutation,
    useGetSharedUsersDashboardMutation,
} from '../../Redux/Workspace/workspaceActionsSlice'
import DetachWorkspaceDialog from '../HomePage/WorkspaceDialogs/DetachWorkspace'
import Dialog from '../../GenericComponents/dialog'
import EditWorkspaceDialog from '../HomePage/WorkspaceDialogs/EditWorkspace'
import { VisualUnitApiDTO_VisualUnit } from '../../Interfaces/APIContracts/VisualUnitApiDTO_VisualUnit'
import { WorkspaceApiDTO_Workspace } from '../../Interfaces/APIContracts/WorkspaceApiDTO_Workspace'
import ShareDashboardComponent from './shareDashboardComponenet'
import SendEmailAsPDFDialog from './sendEmailasPDFDialog'
import EmptyWorkspace from './emptyWorkspace'
import AttachExistingVUDialog from './attachExistingVUDialog'
import CopyExistingVUDialog from './copyExistingVUDialog'
import { FoundationsGenericToaster } from '../../GenericComponents/FoundationsGenericToaster'
import { checkType1 } from '../../GlobalMethods'
import ReorderReportsDialog from './ReorderReportsDialog'
import { Skeleton } from '../../GenericComponents/Skeleton'
import DetailedTooltip from '../../GenericComponents/Tooltip/DetailedTooltip'
import ReportFrame from '../../Components/Reports/ReportFrame'
import { useAddNewReport } from './addNewReport'
import { FoundationsConstants } from '../../FoundationsConstants'
import { useTitleContext } from "../../Hooks/useTitleContext";
import { getVUObject, isChart, isSummary, isTable } from '../../VisualunitHelpers'
import { StatPortalIdProvider } from '../../Components/StatCase/StatCaseFormHooks/StatPortalIdContext'
import { VisualUnitApiDTO_VisualUnit_Extended } from '../../Interfaces/VisualUnit/VisualUnitApiDTO_VisualUnit'
import { setCurrentUserData,useUpdateUserDataMutation } from '../../Redux/User/userSlice'
import { useLocation } from 'react-router-dom'
import React from 'react'
import { Zustand_VisualUnitProvider } from '../../Components/Reports/vuContext'
import { createZustandScopedVisualUnitStore } from '../../Redux/zustand_VisualUnitStore'
import { createWorkspaceStore, useWorkspaceStore, useZustandWorkspaceStore, Zustand_WorkspaceProvider } from './workspaceContext'
import HandleAnyPopupMessage from '../../Components/handleAnyPopupMessage'

declare const window: any
const UnicornApp = window.unicornInstance as any
export interface WorkspaceActionsProps {
    Name?: string
    PrivacyLock: number
    isWorkspaceDropdown?: boolean
    isHomePopUp?: boolean
    currentColor?: string
    workspaceId?: number
    showAddWorkspace?: boolean
    showAddWorkspaceReport?: boolean
    showShareOption?: boolean
    showAttachReportOption?: boolean
    CopyExistingReport?: boolean
    showReOrderOption?: boolean
    showEmailPDF?: boolean
    showDetachOption?: boolean
    showDeleteWorkspaceOption: boolean
    showEditWorkspaceOption?: boolean
    isFavorites?: boolean
    isKMIs?: boolean
    appGUID?: string
    IncludeInEmail?: string
}
// export const triggerStore = (
//     vuId: number,
//     loadingPosition: TloadingPosition,
//     triggerLoadingState: TtriggerLoadingState,
//     triggerKey: null | number,
//     isLoading: boolean,
//     dispatch: any
// ) => {
//     let now = Date.now()
//     dispatch(
//         setTriggerState({
//             vuId,
//             loadingPosition: loadingPosition,
//             triggerLoadingState: triggerLoadingState,
//             triggerKey: now,
//             isLoading: isLoading,
//         })
//     )
// }

export const AttachExistingReportContext = createContext<any>(null)

export const getMessageStatusFieldMsg = (status: any, fieldName: string) => {
    var fieldMsg = ''
    //now status is object
    if (Object.keys(status).length > 0) {
        let messageResults = status?.Field
        if (messageResults === fieldName) {
            return (fieldMsg = messageResults.Message)
        }
    }
    return fieldMsg
}
export const getVUMeasureObject = () => {
    let vuMeasure: IVuMeasure = {
        id: -1,
        displayOrder: 0,
        axisSubType: FoundationsEnums.AxisSubType.None,
        aggregateFunction: '',
        businessParameterId: 0,
        singleValueReportId: 0,
        categoryName: '',
        compCategoryName: [],
        factGroup: [],
        measureSetId: undefined
    }

    return vuMeasure
}
export interface IVuMeasure {
    id: number
    displayOrder: number
    axisSubType: number
    aggregateFunction: string
    businessParameterId: number
    singleValueReportId: number
    categoryName: string
    compCategoryName: any[]
    factGroup: any[]
    measureSetId?: number
}
export const markVisualUnitFavorite = (
    dashBoardId: string,
    visualUnitId: number,
    name: string,
    isAdded: boolean,
    apiState: any
) => {
    const method = isAdded ? 'DELETE' : 'PUT'
    // Prepare the body only for PUT requests
    const body = {
        DashBoardId: dashBoardId,
        VisualUnitId: visualUnitId,
        Name: name,
    }

    apiState({ body, method }) // Pass undefined body for DELETE
        .then((response: any) => {
            if (response && response.data) {
                if (response.data.statusCode == 204) {
                    FoundationsGenericToaster(
                        'success',
                        isAdded
                            ? `Report ${name} successfully removed from Favorites.`
                            : `Report ${name} successfully added to Favorites.`
                    )
                } else {
                    FoundationsGenericToaster('error', response.data.statusMessage)
                }
            }
        })
        .catch((error: any) => {
            console.error('Error from Common function of Favorite:', error)
        })
}

export const getVUFilterableObject = () => {
    let vuFilterable = {
        id: -1,
        displayOrder: 0,
        filterValue: '',
        filterValueListId: "",
        filterDisplayText: '',
        filterOptions: '',
        InputFilterType: 0,
        bpId: undefined
    }
    return vuFilterable
}

export const getVUDimensionRowObject = () => {
    let vuDimensionRow: any = {}
    vuDimensionRow.id = -1
    vuDimensionRow.displayOrder = 0
    vuDimensionRow.metaDataBinId = 0
    return vuDimensionRow
}

export const getVUDimensionColObject = () => {
    let vuDimensionCol: any = {}
    vuDimensionCol.id = -1
    vuDimensionCol.displayOrder = 0
    vuDimensionCol.metaDataBinId = 0
    return vuDimensionCol
}

export const parseFilterValueAndOptions = (value: any) => {
    let parseData: any = {}
    parseData.filterValue = value
    parseData.filterOptions = ''

    var regEx = new RegExp('\\[(.*)\\] \\[(.*)\\] \\[(.*)\\]')
    var matches = regEx.exec(value)
    if (matches != null) {
        parseData.filterValue = matches[3]
        parseData.filterOptions = matches[1] + '_' + matches[2]
    }

    return parseData
}

export interface IGetVuObj {
    id: number
    name: string
    description: string
    viewerType: number
    preview: 'N' | 'Y'
    refreshInterval: number
    privacyLock: number
    measures: any[]
    filterable: any[]
    dimensionRow: any[]
    dimensionCol: any[]
}

interface ZustandVisualUnitContextWrapperProps {
  children: any; //@steven, need help in removing this any.
}

export const ZustandVisualUnitContextWrapper = ({ children }: ZustandVisualUnitContextWrapperProps) => {
  const store = React.useMemo(() => createZustandScopedVisualUnitStore(), []);

  return (
    <Zustand_VisualUnitProvider store={store}>
      {children}
    </Zustand_VisualUnitProvider>
  );
};


export const ZustandWorkspacePageContextWrapper = (props: any) => {
  const store = React.useMemo(() => createWorkspaceStore(), []);

  return (
    <Zustand_WorkspaceProvider store={store}>
      <WorkspacePage {...props} />
    </Zustand_WorkspaceProvider>
  );
};

function WorkspacePage(props: any) {

    const { setTitle } = useTitleContext();
    const wsid = props[1]
    const dispatch = useDispatch()
    const [callWorkspace] = useSubmitFormMutation()
    const [favShine, setFavShine] = useState(false)
    const [favStarOn, setFavStarOn] = useState(false)
    const [favTitle, setFavTitle] = useState(false)
    const [vuObjInfo, setVuObjInfo] = useState<any[]>([])
    const [vuParamsInfo, setVuParamsInfo] = useState<any[]>([])
    const [refreshKey, setRefreshKey] = useState(0) // Key to trigger re-render
    const [needsWorkspaceRefresh, setNeedsWorkspaceRefresh] = useState(true)
    const handleRefreshWorkspace = () => {
        if(needsWorkspaceRefresh === true)
            callWorkspaceFn(wsid) // wsid API Call to refresh workspace data
        setRefreshKey((prevKey) => prevKey + 1) // Increment key to force re-render
    }
    const currentUserData = useSelector((state: RootState) => getCurrentUserData(state))
    const appSettings = useSelector((state: RootState) => {
        const settings = getAppSettings(state);
        if (!settings?.firstToExpand?.Value) {
            return null;
        }
        return settings;
    });
    const [isAddNewWorkpsaceDialogOpen, setIsAddNewWorkpsaceDialogOpen] = useState(false)
    const [isDetachWorkpsaceDialogOpen, setIsDetachWorkpsaceDialogOpen] = useState(false)
    const [isEditWorkpsaceDialogOpen, setIsEditWorkpsaceDialogOpen] = useState(false)
  
    const showAddNewWorkspaceDialog = () => setIsAddNewWorkpsaceDialogOpen(true)
    const CheckDetachWorkspace = () => setIsDetachWorkpsaceDialogOpen(true)
    const hdleEditWorkspace = () => setIsEditWorkpsaceDialogOpen(true)
    const showCopyExistingVisualUnitDialog = () => setshowCopyExistingPopup(true)
    const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false)
    const [deleteDialogMessage, setdeleteDialogMessage] = useState('')
    const [checkDeleteWorkspace] = useCheckDeleteWorkspaceMutation()
    const [isEmailSent, setIsEmailSent] = useState(false)
    const [shareDashBoardElement, setDashBoardElement] = useState('')
    const [showPopup, setShowPopup] = useState(false)
    const [getSharedUsersDashboard] = useGetSharedUsersDashboardMutation()
    const [attachExistingElement, setAttachExistingElement] = useState('')
    const [showAttachExistingPopup, setshowAttachExistingPopup] = useState(false)
    const [getDBVisualUnits] = useGetDBVisualUnitsMutation()
    const [saveAsPDF, setSaveAsPDF] = useState<boolean>(false)
    const [showCopyExistingPopup, setshowCopyExistingPopup] = useState(false)
    const [vuData, setVuData] = useState<VisualUnitApiDTO_VisualUnit_Extended>()
    //TODO: FP-11694 - Remove this later.
    //const [reportData, setReportData] = useState<VisualUnitApiDTO_VisualUnit_Extended[]>([])
    const [isreorderDialogOpen, setReorderDialogOpen] = useState(false)
    const [isReordered, setIsReordered] = useState(false)
    const [isLoading,setIsLoading] = useState<boolean>(true);
    const [sharedUsersCount, setSharedUsersCount] = useState<number>(0);


    const [isInitialized, setIsInitialized] = useState(false);
    const isFirstRender = useRef(true);
    const [removeFromWorkspace, setremoveFromWorkspace] = useState<{ flag: boolean; id: number }>({
        flag: false,
        id: -1,
      });

    const setupWorkspace = useWorkspaceStore((s) => s.setupWorkspace);
    const bulkUpdateVUs = useWorkspaceStore((s) => s.updateVisualUnits);
    const currentWorkspaceData: WorkspaceApiDTO_Workspace = useWorkspaceStore((s) => s.workspaceState);

    useEffect(() => {
        if (isFirstRender.current && appSettings?.firstToExpand?.Value) {
            isFirstRender.current = false;
            setIsInitialized(true);
        }
    }, [appSettings]);
    useEffect(() => {
        if (isInitialized && wsid) {
            callWorkspaceFn(wsid);
        }
    }, [wsid, isInitialized]);

    // Todo: to be implemented for summary.
    const updateAllTableVUsOrSpecific = (key: keyof VisualUnitApiDTO_VisualUnit_Extended, value: any, limit?: number,VuId?:number) => {
        if (limit) {
            let counter = 0
            const newVus = [...(currentWorkspaceData.VisualUnits)].map((vu, index) => {
                if (!isSummary(vu) && counter < limit) {
                    counter++
                    return {
                        ...vu,
                        [key]: value,
                    }
                }
                return vu
            })

            bulkUpdateVUs(newVus)
            return
        }
        else if (VuId) {
            const newVus = [...(currentWorkspaceData.VisualUnits)].map((vu) => {
                if (vu.VisualUnitId === VuId) {
                    return {
                        ...vu,
                        [key]: value,
                    }
                }
                return vu
            })
            bulkUpdateVUs(newVus)
            return
        }
        const newVus = [...(currentWorkspaceData.VisualUnits)].map((vu) => {
            return {
                ...vu,
                [key]: value,
            }
        })
        bulkUpdateVUs(newVus)
    }

    const assignExpandFirstRows = (vuData: VisualUnitApiDTO_VisualUnit_Extended[]) => {
        const ExpandFirstRows = parseInt(appSettings?.firstToExpand?.Value);
    
        if (!isNaN(ExpandFirstRows) && ExpandFirstRows > 0) {
            const newVus = vuData.map((vu, index) => ({
                ...vu,
                Collapsed: index > (ExpandFirstRows-1)
            }));
            return newVus;
        }
        return vuData;  // Return null if settings aren't ready
    };
    



    const [attachExistingReportData, setAttachExistingReportData] = useState<any>({
        visualUnitsTable: [],
        gaugeSummaryBlockView: [],
    })
    //   const [publicAppSettings, setPublicAppSettings] = useState({
    //       defaultSelectPalette: "",
    //       kmiFrequency: "",
    //       defaultRefinementProfile: ""

    //   });
    const getVUParamsObject = () => {
        var vuObject: any = {}
        vuObject.id = -1
        vuObject.params = null
        return vuObject
    }
    //TODO: DP-10887 - Reinstate this
    // useEffect(() => {
    //     if (appSettingData !== undefined && Object.keys(appSettingData).length > 0) {
    //         callWorkspaceFn(wsid) //Please change this wsid as per your workspace
    //         setAppSettingsFn()
    //         UnicornApp.createBusinessParametersList() //Need to call for render proper gauges for BP targets.
    //     }
    // }, [appSettingData])

    useEffect(() => {
        if (wsid)
        callWorkspaceFn(wsid.split('/')[0])
        // UnicornApp.createBusinessParametersList()
    }, [attachExistingReportData])

    useEffect(() => {
        if (isReordered&&wsid) {
            callWorkspaceFn(wsid.split('/')[0]);
            setIsReordered(false);
        }
    }, [isReordered]);

    const location = useLocation();
    const regex = /#workspace\/KMIs\/notifications\/(.*)/;
    const match = location.hash.match(regex);

    const IncludeInEmail = match ? match[1] : 'None';
    const callWorkspaceFn = (wsid: any) => {
        if (!wsid || !isInitialized) return;
            // Call the API with wsid
            const processedWsid = wsid.match(/KMIs\/notifications\/(.*)/) ? wsid.split('/')[0] : wsid;
            callWorkspace({ wsid: processedWsid }) // Add the appropriate body data here
                .unwrap()
                .then((response: any) => {
                    if (response.statusCode == 200) {
                        //TODO: FP-11694 - Delete this block

                        let tableReports: any[] = []
                        let vuObjectInfo: any[] = []
                        let vuParamsObjectInfo: any[] = []

                        if (response?.data?.VisualUnits?.length > 0) {
                            response?.data?.VisualUnits.forEach((itr: any) => {
                                let vuObject = getVUObject()
                                let vuParamsObject = getVUParamsObject()
                                vuObject.id = itr?.VisualUnitId
                                vuParamsObject.id = itr?.VisualUnitId
                                vuObjectInfo.push(vuObject)
                                vuParamsObjectInfo.push(vuParamsObject)

                                if (!isSummary(itr) &&  (itr?.XAxisList.length != 0 || itr?.YAxisList.length != 0) ) {
                                    tableReports.push(itr)
                                }
                            })
                            setVuParamsInfo(vuParamsObjectInfo)
                            setVuObjInfo(vuObjectInfo)
                            setIsLoading(false)
                            dispatch(setVuObjectInfoStore({ data: vuObjectInfo }))
                            dispatch(setVuParamsInfoStore({ data: vuParamsObjectInfo }))

                        }
                        else {
                            // Clear the state when no VisualUnits are present
                            setVuParamsInfo([]);
                            setVuObjInfo([]);
                            setIsLoading(false)
                            dispatch(setVuObjectInfoStore({ data: [] }));
                            dispatch(setVuParamsInfoStore({ data: [] }));
                        }
                        
                        setupWorkspace(response.data) //in Zustand Store
                        setSharedUsersCount(response.data.SharedUsersCount || 0);


                        if (isReordered) {
                            handleRefreshWorkspace();
                            setIsReordered(false);
                        }
                    }
                })
                .catch((error: any) => {
                    console.error('Error fetching Workspace data:', error)
                })
        
    }
    const [showExportPopup, setShowExportPopup] = useState(false);
    const { clickAddNewReport } = useAddNewReport({WorkspaceId : currentWorkspaceData?.WorkspaceId.toString() || "" , setShowExportPopup  })

    useEffect(() => {
        if (currentWorkspaceData) {
            // document.title = 'Foundations - ' + (currentWorkspaceData.Name || 'workspace')
            setTitle(currentWorkspaceData.Name);
        } else {
            setTitle('workspace');
        }
    }, [currentWorkspaceData])

    useEffect(() => {
        if (currentWorkspaceData && currentUserData) {
            dispatch(
                setWorkspaceActions({
                    Name: currentWorkspaceData?.Name,
                    PrivacyLock: currentWorkspaceData?.PrivacyLock,
                    isWorkspaceDropdown: true,
                    isHomePopUp: false,
                    currentColor: currentWorkspaceData.rgborname_color,
                    workspaceId: currentWorkspaceData.WorkspaceId,
                    showAddWorkspace: currentUserData.privileges?.includes('Workspace_Add'),
                    showAddWorkspaceReport:
                        currentUserData.privileges?.includes('VisualUnit_Create') &&
                        currentWorkspaceData?.PrivacyLock ===
                            FoundationsEnums.PrivacyLock.OpenUnlocked,
                    showShareOption: isShareWorkspace(),
                    showAttachReportOption:
                        currentUserData.privileges?.includes('Workspace_AttachVisualUnit') &&
                        currentWorkspaceData?.PrivacyLock ===
                            FoundationsEnums.PrivacyLock.OpenUnlocked,
                    CopyExistingReport:
                        currentUserData.privileges?.includes('VisualUnit_Create') &&
                        currentWorkspaceData?.PrivacyLock ===
                            FoundationsEnums.PrivacyLock.OpenUnlocked,
                    showReOrderOption:
                        currentUserData.privileges?.includes('Workspace_Reorder') &&
                        currentWorkspaceData?.PrivacyLock ===
                            FoundationsEnums.PrivacyLock.OpenUnlocked,
                    showEmailPDF: checkPrivacyLock(),
                    showDetachOption: canDetachWorkspace(currentWorkspaceData.AppGUID),
                    showDeleteWorkspaceOption: canDeleteWorkspace(currentWorkspaceData.AppGUID),
                    showEditWorkspaceOption: canEditWorkspace(),
                    isFavorites: currentWorkspaceData.wsid == 'Favorites',
                    isKMIs: currentWorkspaceData.wsid == 'KMIs',
                    appGUID: currentWorkspaceData.AppGUID,
                    wsid: wsid,
                })
            )
        }
    }, [currentWorkspaceData, currentUserData])

    const CheckDeleteWorkspace = () => {
        const formData = new FormData()
        formData.append('dashBoardId', '' + currentWorkspaceData?.WorkspaceId)

        checkDeleteWorkspace(formData)
            .unwrap()
            .then((response) => {
                if (response?.statusCode === 201) {
                    const resultData = response.data
                    if (resultData) {
                        if (!resultData.allowDelete) {
                            const alertMessage =
                                resultData.lockStatus < 2
                                    ? 'Cannot Delete - Workspace lock status changed.'
                                    : 'Cannot Edit - Workspace lock status changed to high security.'
                            setdeleteDialogMessage(alertMessage)
                            setIsDeleteDialogOpen(true) // Opens dialog in the parent
                        } else {
                            let message = `Are you sure you want to delete this workspace </br><strong>permanently</strong>?<br><br><strong>This operation cannot be undone.</strong>`
                            if (resultData.deleteUserDashBoardsCount > 0) {
                                message += `<br><br>This workspace is used by <strong>${resultData.deleteUserDashBoardsCount} other users</strong>.`
                            }
                            setdeleteDialogMessage(message)
                            setIsDeleteDialogOpen(true) // Opens dialog in the parent
                        }
                    }
                } else if (response?.statusCode === 'OperationNotAllowed') {
                    UnicornApp.toastr(
                        'error',
                        'Sorry, you do not have permission to complete this operation.'
                    )
                }
            })
            .catch((error) => {
                console.error('Error checking delete permissions', error)
            })
    }
    const ReorderReports = () => {
      setReorderDialogOpen(false);
      setTimeout(() => setReorderDialogOpen(true), 0);
    };

    const handleCloseDeleteDialog = () => {
        setIsDeleteDialogOpen(false)
    }

    const handleSendPDF = () => {
        setIsEmailSent(true)
    }
    const handleEmailDialogClose = () => {
        setIsEmailSent(false)
    }
    const extractSharedUsersCount = (data: any) => {
    const sharedUsers = data?.SharedUsersCount || 0; // or wherever shared users are returned
    setSharedUsersCount(sharedUsers);
};
const onShareSuccess= async (wsid: any) => {
    try {
        const response = await callWorkspace({ wsid}).unwrap();
        if (response?.statusCode === 200) {
            extractSharedUsersCount(response.data);
        }
    } catch (error) {
        console.error('Error updating shared users count:', error);
    }
}
    const shareDashbaord = () => {
        setShowPopup(true)
    }
    const showAttachExistingVisualUnitDialog = async () => {
        setshowAttachExistingPopup(true)
    }

    const handleClosePopup = () => {
        setShowPopup(false)
        setshowCopyExistingPopup(false)
        setshowAttachExistingPopup(false)
    }
    const handleSave = (selectedItems: any[]) => {}
    const SharedUsersTooltipContent = () => {
        if (currentWorkspaceData?.SharedUsersCount && currentWorkspaceData?.SharedUsersCount > 0) {
            const sortedUsers = currentWorkspaceData?.SharedUsersInfo?.slice(0, 9).sort(
                (a: any, b: any) => {
                    return a.ShareType === 'Personal' ? -1 : b.ShareType === 'Personal' ? 1 : 0
                }
            )

            const AssignedUsersTooltipContent = () => {
                if (currentWorkspaceData?.RolesForWorkSpace && currentWorkspaceData?.RolesForWorkSpace?.length > 0) {
                    return `<ul>
                  ${currentWorkspaceData.RolesForWorkSpace.map((role: any, index: number) => {
                      return `<li>${role.Name}</li>`
                  }).join('')}
                </ul>`
                }
                return ``
            }

            return `<ul>
            ${sortedUsers
                ?.map((user: any, index: number) => {
                    return `
                    <li key="${index}">
                        <span>${user.FirstName} ${user.LastName}</span>
                        ${
                            user.ShareType === 'Personal'
                                ? `<span class='share-creator'>(creator)</span>`
                                : ''
                        }
                    </li>
                `
                })
                .join('')}
            ${
                currentWorkspaceData?.SharedUsersInfo?.length > 9
                    ? `<li><span>and more.. </span></li>`
                    : ''
            }
        </ul>`
        } else {
            return `<p>No users</p>`
        }
    }

    const AssignedUsersTooltipContent = () => {
        if (currentWorkspaceData?.RolesForWorkSpace && currentWorkspaceData?.RolesForWorkSpace?.length > 0) {
            return `<ul>
          ${currentWorkspaceData.RolesForWorkSpace.map((role: any, index: number) => {
              return `<li>${role.Name}</li>`
          }).join('')}
        </ul>`
        }
        return ``
    }

    const content = AssignedUsersTooltipContent()

    const isWorkspaceSharedWithAnotherNonAdminAndNonCreatorUser = () => {
        if (currentWorkspaceData?.ShareType === FoundationsEnums.DashBoardShareType.ByRole) {
            return false
        }
        if (currentUserData.data?.id !== currentWorkspaceData?.CreatedBy?.id) {
            return (
                !checkType1(currentUserData) &&
                !currentUserData?.privileges?.includes('CustomerAdmin')
            )
        }
        return false
    }
    const isAdminUserProxyingAsANonAdminNonCreator = () => {
        const isAdminProxying =
            !checkType1(currentUserData) &&
            !currentUserData?.privileges?.includes('CustomerAdmin') &&
            currentWorkspaceData?.CreatedBy?.id !== currentUserData.data?.id
        return isAdminProxying
    }
    const isShareWorkspace = () => {
        if (isWorkspaceSharedWithAnotherNonAdminAndNonCreatorUser()) {
            return (
                currentUserData.privileges?.includes('Workspace_Share') &&
                (currentWorkspaceData?.PrivacyLock ===
                    FoundationsEnums.PrivacyLock.PrivateNotVisible ||
                    currentWorkspaceData?.PrivacyLock ===
                        FoundationsEnums.PrivacyLock.OpenUnlocked ||
                    currentWorkspaceData?.PrivacyLock ===
                        FoundationsEnums.PrivacyLock.LockedNotPrivate)
            )
        } else {
            return currentUserData.privileges?.includes('Workspace_Share')
        }
    }
    const checkPrivacyLock = () => {
        const isPrivacyLocked =
            currentWorkspaceData?.PrivacyLock && (currentWorkspaceData?.PrivacyLock > FoundationsEnums.PrivacyLock.OpenUnlocked) &&
            currentWorkspaceData.LastUpdatedByUser !== currentUserData.data?.id
        // Return true if the user is an admin or the privacy lock conditions are not met
        return checkType1(currentUserData) || !isPrivacyLocked
    }
    const canDetachWorkspace = (appGUID?: string) => {
        if (appGUID === null || appGUID === '' || appGUID === undefined) {
            if (
                currentUserData.privileges?.includes('Workspace_Detach') &&
                currentWorkspaceData?.PrivacyLock === FoundationsEnums.PrivacyLock.OpenUnlocked
            ) {
                return true
            }
            return false
        }
        return false
    }
    const canDeleteWorkspace = (appGUID?: string) => {
        if (appGUID === null || appGUID === '' || appGUID === undefined) {
            if (
                currentUserData.privileges?.includes('Workspace_Delete') &&
                currentWorkspaceData?.PrivacyLock === FoundationsEnums.PrivacyLock.OpenUnlocked
            ) {
                return true
            }
            return false
        }
        return false
    }

    const canAddReport = () => {
        return ( currentWorkspaceData?.wsid !== 'Favorites' &&
            currentUserData.privileges?.includes('VisualUnit_Create') &&
            (currentWorkspaceData?.PrivacyLock === FoundationsEnums.PrivacyLock.OpenUnlocked) &&
            // visualUnitsData.length == 0 &&
            // summaryReportsData.length == 0 //Not sure why this is on only if summarys and vus are 0, but not going into it at the moment.
            currentWorkspaceData.VisualUnits.length == 0
        )
    }

    const canAttachReport = () => {
        return ( currentWorkspaceData?.wsid !== 'Favorites' &&
            currentUserData.privileges?.includes('Workspace_AttachVisualUnit') &&
            (currentWorkspaceData?.PrivacyLock === FoundationsEnums.PrivacyLock.OpenUnlocked) &&
            // visualUnitsData.length == 0 &&
            // summaryReportsData.length == 0 //Not sure why this is on only if summarys and vus are 0, but not going into it at the moment.
            currentWorkspaceData.VisualUnits.length == 0
        )
    }
    const canEditWorkspace = () => {
        if (isWorkspaceSharedWithAnotherNonAdminAndNonCreatorUser()) {
            return (
                currentUserData.privileges?.includes('Workspace_Edit') &&
                (currentWorkspaceData?.PrivacyLock ===
                    FoundationsEnums.PrivacyLock.PrivateNotVisible ||
                    currentWorkspaceData?.PrivacyLock ===
                        FoundationsEnums.PrivacyLock.OpenUnlocked ||
                    currentWorkspaceData?.PrivacyLock ===
                        FoundationsEnums.PrivacyLock.LockedNotPrivate)
            )
        } else if (isAdminUserProxyingAsANonAdminNonCreator()) {
            return (
                currentUserData.privileges?.includes('Workspace_Edit') &&
                currentWorkspaceData?.PrivacyLock === FoundationsEnums.PrivacyLock.OpenUnlocked
            )
        } else {
            return currentUserData.privileges?.includes('Workspace_Edit')
        }
    }

    //const currentWorkspaceData = useSelector((state: RootState) => getWorkspaceData(state)?.data);
    // const currentUserData = useSelector((state: RootState) => getCurrentUserData(state)?.data);
    // const publicAppSetting = useSelector((state: RootState) => getPublicAppSetting(state)?.data);

    const [updateUserData] = useUpdateUserDataMutation();
    const [isWorkspaceSetToFav,setIsWorkspaceSetToFav] = useState<boolean>(currentUserData?.UserFavWorkspace === wsid ? true : false)
    const setWorkspaceAsFav = async () => {
        const newIsFav = !isWorkspaceSetToFav;
        setIsWorkspaceSetToFav(newIsFav)
        if (currentUserData) {
            const updatedValueOfuser = {
                ...currentUserData,
                UserFavWorkspace: newIsFav ? wsid : 'home'
            };
            await updateUserData(updatedValueOfuser);
            dispatch(setCurrentUserData({ data: updatedValueOfuser }));
            if(newIsFav)
            {
            FoundationsGenericToaster("success", "Marked as default, the workspace will launch on login.")
            }
            else
            {
                FoundationsGenericToaster("success", "Removed from default, the workspace will no longer launch on login.")
            }
        }
    };

    const [UserVisualUnits, SetUserVisualUnit] = useState<VisualUnitApiDTO_VisualUnit[]>([])

    // FP-10725 Filter VisualUnits before rendering
    // const summaryVisualUnits =
    //     currentWorkspaceData.VisualUnits?.filter((vu: any) => IsSummary(vu)) || []
    // const nonSummaryVisualUnits =
    //     currentWorkspaceData.VisualUnits?.filter((vu: any) => !IsSummary(vu)) || []
      
    useEffect(() => {
        if (
            attachExistingReportData.visualUnitsTable.length > 0 ||
            attachExistingReportData.gaugeSummaryBlockView.length > 0
        ) {
            setNeedsWorkspaceRefresh(false) // Skipping the wsid API call as its handled through useeffect
            handleRefreshWorkspace()
        }
    }, [
        attachExistingReportData.visualUnitsTable.length,
        attachExistingReportData.gaugeSummaryBlockView.length,
    ])

    return !isInitialized || isLoading ? (
        <span>
            <div className="row" style={{ height: '50px' }}></div>
            <div className="row summary-tiles-wrap">
                <Skeleton className="summary-tiles skeleton col" loading={isLoading} />
                <Skeleton className="summary-tiles skeleton col" loading={isLoading} />
                <Skeleton className="summary-tiles skeleton col" loading={isLoading} />
                <Skeleton className="summary-tiles skeleton col" loading={isLoading} />
            </div>
            <div className="row">
                <div className="non-summary-tiles skeleton col"></div>
            </div>
            <div className="row">
                <div className="non-summary-tiles skeleton col"></div>
            </div>
        </span>
    ) : (
        <>
            <StatPortalIdProvider>
                {(() => {
                    const summaries = currentWorkspaceData.VisualUnits.filter(x => isSummary(x))
                    const visualUnits = currentWorkspaceData.VisualUnits.filter(x => !isSummary(x))
                    return (
                        <AttachExistingReportContext.Provider
                            value={{ attachExistingReportData, setAttachExistingReportData }}
                        >
                            <>
                                {currentWorkspaceData?.MessageResults && currentWorkspaceData?.MessageResults?.length > 0 ? (
                                    <>
                                        {/* UnAuthorised Workspace - Start*/}
                                        <div className="padding-large">
                                            Sorry, you do not have permission to view this workspace.
                                            <a href="#home">
                                                <span>View available workspaces.</span>
                                            </a>
                                        </div>
                                        {/* UnAuthorised Workspace - End*/}
                                    </>
                                ) : (
                                    <>
                                        <span id="wlm-modal"></span>
                                        <div className="page-header">
                                            {currentWorkspaceData ? (
                                                <div className="row mx-0">
                                                    <div
                                                        className={`col-md-6 col-lg-9 mb-3 px-1 text-md-left blue-color ${saveAsPDF ? 'text-center' : ''}`} >
                                                        <span className="d-flex">
                                                            <h4
                                                                id={`dashboard_name_${wsid}`}
                                                                className="fw-normal text-overflow"
                                                                style={{ maxWidth: '50%' }}
                                                            >
                                                                {currentWorkspaceData?.Name}
                                                            </h4>
                                                            {currentWorkspaceData?.Name && (
                                                                <a onClick={setWorkspaceAsFav} id="buttonFavWSSaveChanges" className="ml-1 pt-2">
                                                                    <i title={isWorkspaceSetToFav ? 'Remove from favourite' : 'Add to favourite'}
                                                                        className={`feather shine ${isWorkspaceSetToFav ? 'icon-star-on' : 'icon-star'} cursor-pointer`}
                                                                        id="button_FavWSSaveChanges"></i>
                                                                </a>
                                                            )}
                                                        </span>
                                                        <div
                                                            id={`dashboard_description_${wsid}`}
                                                            className="fs-11 text-overflow mx-md-auto float-left"
                                                        >
                                                            {currentWorkspaceData?.Description}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 col-lg-3 mb-xl-2 text-center text-md-right pl-3 d-flex flex-column">
                                                        <div className="workspace-action-padding-fix">
                                                            <WorkspaceActionsDropdown
                                                                visualUnitsData={visualUnits}
                                                                WorkspaceId={
                                                                    currentWorkspaceData.WorkspaceId
                                                                }
                                                                updateAllTableVUsOrSpecific={updateAllTableVUsOrSpecific}
                                                                onAddWorkspaceClick={
                                                                    showAddNewWorkspaceDialog
                                                                }
                                                                onRefresh={handleRefreshWorkspace}
                                                                onDeleteWorkspaceClick={
                                                                    CheckDeleteWorkspace
                                                                }
                                                                onDeatchWorkspaceClick={
                                                                    CheckDetachWorkspace
                                                                }
                                                                onClickSendEmailasPDF={handleSendPDF}
                                                                onClickEditWorkspace={hdleEditWorkspace}
                                                                onClickShareWorkspace={shareDashbaord}
                                                                onClickAttachExisting={
                                                                    showAttachExistingVisualUnitDialog
                                                                }
                                                                onClickCopyExisting={
                                                                    showCopyExistingVisualUnitDialog
                                                                }
                                                                onClickAddNewReport={clickAddNewReport}
                                                                onclickReorderReports={ReorderReports}
                                                            />
                                                        </div>
                                                          <HandleAnyPopupMessage
                                                            isOpen={showExportPopup}
                                                            title="Add new report"
                                                            textClasses = "ajax-page-error"
                                                            message={`Sorry, creating ${FoundationsConstants.enumVULabel.SingularLower} operation failed.`}
                                                            onClose={() => setShowExportPopup(false)}
                                                            Link={null}
                                                            linkText=""
                                                        />

                                                        <DeleteWorkspaceDialog
                                                            isOpen={isDeleteDialogOpen}
                                                            onClose={handleCloseDeleteDialog}
                                                            WorkspaceId={
                                                                '' + currentWorkspaceData.WorkspaceId
                                                            }
                                                        />
                                                        <DetachWorkspaceDialog
                                                            isOpen={isDetachWorkpsaceDialogOpen}
                                                            onClose={() =>
                                                                setIsDetachWorkpsaceDialogOpen(false)
                                                            }
                                                            WorkspaceId={
                                                                '' + currentWorkspaceData.WorkspaceId
                                                            }
                                                        />
                                                        <SendEmailAsPDFDialog
                                                            isOpen={isEmailSent}
                                                            onClose={handleEmailDialogClose}
                                                            WorkspaceId={
                                                                '' + currentWorkspaceData.WorkspaceId
                                                            }
                                                        ></SendEmailAsPDFDialog>

                                                        <EditWorkspaceDialog
                                                            isOpen={isEditWorkpsaceDialogOpen}
                                                            onClose={() =>
                                                                setIsEditWorkpsaceDialogOpen(false)
                                                            }
                                                            DialogState={setIsEditWorkpsaceDialogOpen}
                                                        />

                                                        <ShareDashboardComponent
                                                            isOpen={showPopup}
                                                            dashBoardId={currentWorkspaceData.WorkspaceId}
                                                            onClose={handleClosePopup}
                                                            onShareSuccess={() => {
                                                                onShareSuccess(wsid); // Refresh workspace data to get updated shared users count
                                                            }}
                                                        ></ShareDashboardComponent>

                                                        <AttachExistingVUDialog
                                                            isOpen={showAttachExistingPopup}
                                                            wsid={wsid ?? ''}
                                                            onClose={handleClosePopup}
                                                            WorkspaceId={currentWorkspaceData.WorkspaceId}
                                                        ></AttachExistingVUDialog>

                                                        <CopyExistingVUDialog
                                                            isOpen={showCopyExistingPopup}
                                                            WorkspaceId={currentWorkspaceData.WorkspaceId}
                                                            onClose={handleClosePopup}
                                                        ></CopyExistingVUDialog>
                                                        <ReorderReportsDialog
                                                            isOpen={isreorderDialogOpen}
                                                            WorkspaceId={currentWorkspaceData.WorkspaceId}
                                                            onClose={() => setReorderDialogOpen(false)}
                                                            onRefresh={() => {
                                                                    setIsReordered(true);
                                                                }
                                                            }
                                                            reportsData={currentWorkspaceData.VisualUnits}
                                                        />
                                                        <div className="dashboard-sub-info-wrapper">
                                                            {currentWorkspaceData?.SharedUsersCount ==
                                                            null ? (
                                                                <>
                                                                    <span
                                                                        id="db-sub-info-users-or-roles"
                                                                        className="sub-info-users"
                                                                    >
                                                                        Not shared with users or roles
                                                                    </span>
                                                                    <span className="dashboard-menu-divider">
                                                                        &bull;
                                                                    </span>
                                                                    <span className="dashboard-menu-divider">
                                                                        &bull;
                                                                    </span>
                                                                    <span>Assigned to 0 roles</span>
                                                                    <span
                                                                        id="sub-info-bull"
                                                                        className="dashboard-menu-divider"
                                                                    >
                                                                        &bull;
                                                                    </span>
                                                                    <span
                                                                        id="sub-info-personal"
                                                                        className="sub-info-sharetype"
                                                                    >
                                                                        Personal
                                                                    </span>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    {!(
                                                                        currentWorkspaceData?.SharedUsersCount >
                                                                        0
                                                                    ) ? (
                                                                        <span
                                                                            id="db-sub-info-users-or-roles"
                                                                            className="sub-info-users"
                                                                        >
                                                                            Not shared
                                                                        </span>
                                                                    ) : (
                                                                        <>
                                                                            {currentWorkspaceData?.SharedUsersInfo?.slice(
                                                                                0,
                                                                                9
                                                                            )?.length != 0 && (
                                                                                <>
                                                                                    <span
                                                                                        id="db-sub-info-users-or-roles"
                                                                                        className="sub-info-users"
                                                                                    >
                                                                                        Shared with{' '}
                                                                                    </span>
                                                                                    <span
                                                                                        id="dashboard_users_tooltip"
                                                                                        className="tooltip-info-link"
                                                                                    >
                                                                                        {currentWorkspaceData?.SharedUsersInfo
                                                                                            ? sharedUsersCount -
                                                                                            1
                                                                                            : null}
                                                                                        &nbsp;
                                                                                        <DetailedTooltip
                                                                                            content={SharedUsersTooltipContent()}
                                                                                            targetEl={
                                                                                                'dashboard_users_tooltip'
                                                                                            }
                                                                                            allowHTML={
                                                                                                false
                                                                                            }
                                                                                            showIcon={false}
                                                                                            placement="bottom"
                                                                                        />
                                                                                        {currentWorkspaceData
                                                                                            ?.SharedUsersInfo
                                                                                            ?.length == 1
                                                                                            ? 'user'
                                                                                            : 'users'}
                                                                                    </span>
                                                                                    {/* <div
                                                                                        id="hide-names"
                                                                                        className="hide"
                                                                                    >
                                                                                        <div className="tooltip-help-data">
                                                                                            <ol className="tooltip-help-list">
                                                                                                {currentWorkspaceData?.SharedUsersInfo?.slice(
                                                                                                    0,
                                                                                                    9
                                                                                                ).map(
                                                                                                    (
                                                                                                        user: any,
                                                                                                        index: number
                                                                                                    ) => (
                                                                                                        <>
                                                                                                            <li>
                                                                                                                <span>
                                                                                                                    {
                                                                                                                        user.FirstName
                                                                                                                    }{' '}
                                                                                                                    {
                                                                                                                        user.LastName
                                                                                                                    }
                                                                                                                </span>
                                                                                                                {user.ShareType ==
                                                                                                                    'Personal' && (
                                                                                                                    <span className="share-creator">
                                                                                                                        (creator)
                                                                                                                    </span>
                                                                                                                )}
                                                                                                            </li>
                                                                                                        </>
                                                                                                    )
                                                                                                )}
                                                                                                {currentWorkspaceData
                                                                                                    ?.SharedUsersInfo
                                                                                                    ?.length >
                                                                                                    9 && (
                                                                                                    <li>
                                                                                                        <span>
                                                                                                            and
                                                                                                            more..{' '}
                                                                                                        </span>
                                                                                                    </li>
                                                                                                )}
                                                                                            </ol>
                                                                                        </div>
                                                                                    </div> */}
                                                                                </>
                                                                            )}
                                                                        </>
                                                                    )}
                                                                    {currentUserData?.privileges !==
                                                                        undefined &&
                                                                        currentUserData?.privileges
                                                                            .length !== 0 &&
                                                                        currentUserData?.privileges?.includes(
                                                                            'Workspace_Edit'
                                                                        ) && (
                                                                            <>
                                                                                <span className="dashboard-menu-divider">
                                                                                    &bull;
                                                                                </span>
                                                                                <span>Assigned to </span>
                                                                                <span
                                                                                    id="dashboard_roles_tooltip"
                                                                                    className="tooltip-info-link"
                                                                                >
                                                                                    {
                                                                                        currentWorkspaceData
                                                                                            ?.RolesForWorkSpace
                                                                                            ?.length              // fixing KMI workspace failure
                                                                                    }{' '}
                                                                                    {content ? (
                                                                                        <DetailedTooltip
                                                                                            content={AssignedUsersTooltipContent()}
                                                                                            targetEl={
                                                                                                'dashboard_roles_tooltip'
                                                                                            }
                                                                                            allowHTML={
                                                                                                false
                                                                                            }
                                                                                            showIcon={false}
                                                                                            placement='bottom'
                                                                                        />
                                                                                    ) : (
                                                                                        <></>
                                                                                    )}
                                                                                    {currentWorkspaceData
                                                                                        ?.RolesForWorkSpace
                                                                                        ?.length == 1
                                                                                        ? 'role'
                                                                                        : 'roles'}
                                                                                </span>
                                                                                {/* <div className="hide">
                                                                                    <div className="tooltip-help-data">
                                                                                        <ol className="tooltip-help-list">
                                                                                            {currentWorkspaceData?.RolesForWorkSpace.map(
                                                                                                (
                                                                                                    role: any,
                                                                                                    index: number
                                                                                                ) => (
                                                                                                    <li>
                                                                                                        {
                                                                                                            role.Name
                                                                                                        }
                                                                                                    </li>
                                                                                                )
                                                                                            )}
                                                                                        </ol>
                                                                                    </div>
                                                                                </div> */}

                                                                                {/* isPersonal doesn't exist on currrentWorkspaceData */}
                                                                                {currentWorkspaceData?.ShareType == FoundationsEnums.DashBoardShareType.Personal && (
                                                                                    <>
                                                                                        <span
                                                                                            id="sub-info-bull"
                                                                                            className="dashboard-menu-divider"
                                                                                        >
                                                                                            &bull;
                                                                                        </span>
                                                                                        <span
                                                                                            id="sub-info-personal"
                                                                                            className="sub-info-sharetype"
                                                                                        >
                                                                                            Personal
                                                                                        </span>
                                                                                    </>
                                                                                )}
                                                                            </>
                                                                        )}
                                                                </>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <AddWorkspaceDialog
                                                            isOpen={isAddNewWorkpsaceDialogOpen}
                                                            onClose={() =>
                                                                setIsAddNewWorkpsaceDialogOpen(false)
                                                            }
                                                        />
                                                </div>
                                            ) : (
                                                <div></div> // Placeholder for loading state if currentWorkspaceData is not available
                                            )}
                                        </div>
                                        <div key={refreshKey}>
                                            <div className="page-body" id="visualunits_content">
                                                <div id="ctl00_app_master_main_container_div_dashboard_vus">
                                                    <div id="new_report_summary_el">
                                                    {currentWorkspaceData.VisualUnits.length == 0 && !isLoading ? (  // FP-12063 - Visual units: "The message "No reports are present in this workspace" is displayed when the user load any workspace.
                                                <div id="empty-workspace">
                                                        <EmptyWorkspace
                                                            wsid={props?.ws_id ?? ''}
                                                            WorkspaceId={currentWorkspaceData?.WorkspaceId?.toString() || ""}
                                                            showAddWorkspaceReport={canAddReport()}
                                                            showAttachReportOption={canAttachReport()}
                                                            showAttachExistingVisualUnitDialog={showAttachExistingVisualUnitDialog}
                                                        ></EmptyWorkspace>
                                                </div>
                                                )
                                                        : summaries.length > 0 && (
                                                            (IncludeInEmail === "None" || summaries.some(visualunit => visualunit.IncludeInEmail === IncludeInEmail)) && (
                                                            <div
                                                                id="vu_summary_view"
                                                                className="padding-top-large padding-bottom-medium col-12 no-gutters"
                                                                style={{ display: 'block' }}
                                                            >
                                                                <div
                                                                    id="summary_view_data_grid"
                                                                    className="container-fluid"
                                                                >
                                                                    <div
                                                                        id="summary_view_data_grid"
                                                                        className="container-fluid"
                                                                    >
                                                                        {summaries.map(
                                                                            (visualunit: VisualUnitApiDTO_VisualUnit) => {
                                                                                const actionType = visualunit?.callerType === FoundationsConstants.enumVUCallerType.Explore
                                                                                    ? 'copyVU' // FP-11689 Copied report should open in Summary Edit palette
                                                                                    : '';
                                                                                var props = {
                                                                                    ...visualunit,
                                                                                };

                                                                                // First condition check
                                                                                if (IncludeInEmail !== "None") {
                                                                                    // Check if IncludeInEmail matches
                                                                                    if (visualunit.IncludeInEmail === IncludeInEmail) {
                                                                                        return (
                                                                                            <ZustandVisualUnitContextWrapper>
                                                                                                <IndividualSummary
                                                                                                    key={visualunit.VisualUnitId + '_visualunit'}
                                                                                                    vuDetails= {{
                                                                                                            ...visualunit,
                                                                                                            DashBoardId: currentWorkspaceData?.WorkspaceId || -1,
                                                                                                            BuildQuery: false,
                                                                                                            Collapsed: false,
                                                                                                            SnapshotCount: 0
                                                                                                        }}
                                                                                                    DashBoardId={currentWorkspaceData?.WorkspaceId || -1}
                                                                                                    setVuData={setVuData}
                                                                                                    actionType={actionType}
                                                                                                    setremoveFromWorkspace={setremoveFromWorkspace}  
                                                                                                />
                                                                                            </ZustandVisualUnitContextWrapper>
                                                                                        );
                                                                                    } else {
                                                                                        // If IncludeInEmail doesn't match, render nothing (or return null/empty string if preferred)
                                                                                        return null;
                                                                                    }
                                                                                } else {
                                                                                    // If IncludeInEmail is "None", render the IndividualSummary regardless
                                                                                    return (
                                                                                        <ZustandVisualUnitContextWrapper>
                                                                                            <IndividualSummary
                                                                                                key={visualunit.VisualUnitId + '_visualunit'}
                                                                                                vuDetails={{
                                                                                                            ...visualunit,
                                                                                                            DashBoardId: currentWorkspaceData?.WorkspaceId || -1,
                                                                                                            BuildQuery: false,
                                                                                                            Collapsed: false,
                                                                                                            SnapshotCount: 0
                                                                                                        }}
                                                                                                DashBoardId={currentWorkspaceData?.WorkspaceId || -1}
                                                                                                actionType={actionType}
                                                                                                setVuData={setVuData}
                                                                                                setremoveFromWorkspace={setremoveFromWorkspace} 
                                                                                            />
                                                                                        </ZustandVisualUnitContextWrapper>
                                                                                    );
                                                                                }
                                                                            }
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            )
                                                        )}
                                                        <div id="report_tabular_el">
                                                            {visualUnits.length > 0 && (
                                                                <div id="vu_report_view">
                                                                    <div
                                                                        id="report_view_data_grid"
                                                                    >
                                                                        {visualUnits.map(
                                                                            (reports: VisualUnitApiDTO_VisualUnit_Extended) => {
                                                                                const actionType =
                                                                                    reports.TempVisualUnitId === -1
                                                                                        ? 'addNewVU'
                                                                                        : reports.callerType === FoundationsConstants.enumVUCallerType.Explore
                                                                                            ? 'copyVU'
                                                                                            : '';

                                                                                // First condition check
                                                                                if (IncludeInEmail !== "None") {
                                                                                    // Check if IncludeInEmail matches
                                                                                    if (reports.IncludeInEmail === IncludeInEmail) {
                                                                                        return (
                                                                                            <>
                                                                                                <ZustandVisualUnitContextWrapper>
                                                                                                    <ReportFrame
                                                                                                        key={reports.VisualUnitId + '_visualunit'}
                                                                                                        report={{
                                                                                                            ...reports,
                                                                                                            DashBoardId: currentWorkspaceData?.WorkspaceId || -1,
                                                                                                        }}
                                                                                                        dashboardId={currentWorkspaceData?.WorkspaceId || -1}
                                                                                                        wsid={wsid}
                                                                                                        collapsed={reports.Collapsed}
                                                                                                        actionType={actionType} // action={actionType}
                                                                                                        setVuData={setVuData}
                                                                                                        setremoveFromWorkspace={setremoveFromWorkspace}                                                                        
                                                                                                        updateAllTableVUsOrSpecific={updateAllTableVUsOrSpecific}
                                                                                                    >
                                                                                                        </ReportFrame>
                                                                                                </ZustandVisualUnitContextWrapper>
                                                                                            <div className="clear-both"></div>
                                                                                            </>
                                                                                        );
                                                                                    } else {
                                                                                        // If IncludeInEmail doesn't match, render nothing (or return null/empty string if preferred)
                                                                                        return null;
                                                                                    }
                                                                                } else {
                                                                                    // If IncludeInEmail is "None", render the ReportFrame regardless
                                                                                    return (
                                                                                        <>
                                                                                            <ZustandVisualUnitContextWrapper>
                                                                                                <ReportFrame
                                                                                                    key={reports.VisualUnitId + '_visualunit'}
                                                                                                    report={{
                                                                                                        ...reports,
                                                                                                        DashBoardId: currentWorkspaceData?.WorkspaceId || -1,
                                                                                                    }}
                                                                                                    dashboardId={currentWorkspaceData?.WorkspaceId || -1}
                                                                                                    wsid={wsid}
                                                                                                    collapsed={reports.Collapsed}
                                                                                                    actionType={actionType} // action={actionType}
                                                                                                    setVuData={setVuData}
                                                                                                    setremoveFromWorkspace={setremoveFromWorkspace}                                                                        
                                                                                                    updateAllTableVUsOrSpecific={updateAllTableVUsOrSpecific}
                                                                                                />
                                                                                            </ZustandVisualUnitContextWrapper>
                                                                                            <div className="clear-both"></div>
                                                                                        </>
                                                                                    );
                                                                                }
                                                                            }
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            )}
                                                            {/* //Add Table Report Call Here */}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    
                                        {Object.keys(appSettings).length > 0 && (
                                            <>
                                                <div
                                                    className="selectPalette hide"
                                                    // data-defaultSelectType={
                                                    //     appSettings.defaultSelectPalette
                                                    // }
                                                ></div>
                                                <div
                                                    className="hidden kmiDefaultFrequency_div"
                                                    id="kmiDefaultFrequency_div"
                                                ></div>
                                                <div
                                                    className="hidden enableRefinement_div"
                                                    id="enableRefinement_div"
                                                    // data-defaultRefinementProfile={
                                                    //     appSettings.defaultRefinementProfile
                                                    // }
                                                ></div>
                                                <div id="vu_rubric_dialog_wrapper" className=""></div>
                                            </>
                                        )}
                                    </>
                                )}
                            </>
                        </AttachExistingReportContext.Provider>
                        )
                    })()}
                    </StatPortalIdProvider>
        </>
    )
}

export default WorkspacePage
